
import styles from "./Footer.module.css"
import {FaLinkedin} from "react-icons/fa"
import {GrTwitter} from "react-icons/gr"
import {MdEmail} from "react-icons/md"
import {BsTelephoneOutboundFill} from "react-icons/bs"
import {BsGithub} from "react-icons/bs"
import Inputdata from "./Inputdata"

export const Footer = () => {

return(

<div name="contact" className={styles.footerdiv} >

<h1>Get in Touch</h1>
<h2>Ravinder Saini</h2>


<div className={styles.footer}>
<a href="https://www.linkedin.com/in/ravinder-k-120b4b197"><FaLinkedin size={40}/></a>
<a href="mailto:iamraviamar@gmail.com"><MdEmail size={40}/></a>

<a href="https://github.com/RavinderTakda" >< BsGithub size={40}/></a>

<div className={styles.telephone}>
  <a className={styles.telephoneicon}  href="tel:+91-830-693-9494" ><BsTelephoneOutboundFill size={40}/></a>
  <a  href="tel:+91-830-693-9494">+91 8306939494</a>
</div>


</div>

{/* 
<div >

  <input style={{"width":"250px","height":"24px","marginTop":"20px"}} placeholder="Name"></input>
  <br/>
<input style={{"width":"250px","height":"24px","marginTop":"20px"}}  placeholder="Email"></input>
<br/>
<input style={{"width":"250px","height":"80px","marginTop":"20px"}}  placeholder="Messages"></input>

<button style={{"display":"block",'margin':"auto","marginTop":"20px"}}>Submit</button>



</div> */}

<Inputdata/>

<p>© 2020 copyright all right reserved </p>


</div>


)




}